import DotChip from 'components/Find/DotChip';
import { DetailSection } from 'components/Find/detail';
import type { FindPlayerAvailabilitySlot } from 'components/Find/types';

interface Props {
  availability: FindPlayerAvailabilitySlot[];
  /** `lg`: the heading steps up from lg, for Figma's wider "Modal M". */
  sizeDesktop?: 'lg';
}

export default function PlayerAvailability({ availability, sizeDesktop }: Props) {
  return (
    <DetailSection title="Available on" sizeDesktop={sizeDesktop}>
      <div className="flex flex-wrap gap-ds-sm">
        {availability.map((slot) => (
          <DotChip
            key={`${slot.day}-${slot.timeLabel}`}
            label={slot.day}
            detail={slot.timeLabel}
            size="md"
          />
        ))}
      </div>
    </DetailSection>
  );
}
